module.exports = __webpack_public_path__ + "static/media/girl-20.3ddf4041.svg";